import { render, staticRenderFns } from "./SearchFieldSelectorV2.vue?vue&type=template&id=a1e589c8"
import script from "./SearchFieldSelectorV2.vue?vue&type=script&lang=js"
export * from "./SearchFieldSelectorV2.vue?vue&type=script&lang=js"
import style0 from "./SearchFieldSelectorV2.vue?vue&type=style&index=0&id=a1e589c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports